import _ from "lodash";
import { connect } from "react-redux";

import { PictureContent } from "./content";
import { ActionTypes } from "@/Apps/Pages/Properties/BuildingBlocks/Interactions/types";
import { parseLiquidString, parseLiquidStringWithLiquidJS, parseLiquidObject } from "@/Apps/Pages/Page/LiquidRenderer";
import { PageContext } from "@/Apps/Pages/Page/PageContext";
import { useContext } from "react";

const Content = (props: any) => {
  const { actions } = props.settings;
  const pageContext = useContext(PageContext);

  const haslink = _.head(_.filter(actions, itm => itm.behavior === "click" &&
    (itm.type === ActionTypes.GO_TO_URL || itm.type === ActionTypes.TRIGGER_NEXT_NODE || itm.type === ActionTypes.DOWNLOAD_FILE || itm.type === ActionTypes.TRIGGER_WEBHOOK)
  ));

  const href = haslink ? _.get(props.settings, "href", _.get(props.settings, "actions[0].payload.url", false)) : false;

  const src = parseLiquidStringWithLiquidJS(props.settings?.src, pageContext);

  // console.log("Picture", props.settings, "Parsed Source", newSrc);

  return (
    <>
      <PictureContent
        {...props}
        settings={{
          ...props.settings,
          src,
          href
        }}
      />
    </>
  );
};

export const Picture = (props: any) => {
  const { settings } = props;

  const marginTop = settings.properties ? settings.properties.marginTop : 0;
  const padding = settings.properties ? settings.properties.padding : 0;
  const textAlign = settings.properties ? settings.properties.textAlign : "inherit";
  const display = settings.properties ? settings.properties.display : 'inline-block';
  // const position = settings.properties ? settings.properties.position : 'relative';

  const handleClick = () => {
    const {
      dispatch,
      settings,
      fieldValues,
      updateComponentSettings,
      getComponentSettings
    } = props;
    const { actions } = settings;

    if (actions) {
      const doTheseActions = actions.filter(itm => itm.behavior === "click");
      doTheseActions.forEach(action =>
        dispatch({
          ...action,
          settings: { ...settings, fieldValues },
          updateComponentSettings,
          getComponentSettings
        })
      );
    }
  };

  return (
    <div
      data-testid="WC-PICTURE-LIVE"
      style={parseLiquidObject({ marginTop, textAlign })}>
      <div onClick={handleClick} style={parseLiquidObject({ padding, display, position: 'relative' })}>
        <Content {...props} />
      </div>
    </div>
  );
};

// export default connect()(Picture);
export default Picture;
